import ptBrTranslations from './pt-br';
import enUsTranslations from './en-us';

const index = {
    'pt-BR' : ptBrTranslations,
    'en-US' : enUsTranslations
}

export default index;